import React, { useState, useEffect } from "react";
import Select from "react-select";
import config from "react-global-configuration";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";
import ReactModal from "react-modal";
import Cookies from "js-cookie";

const TEMPLATE_URL = "https://admin.asthu.com";
const PRODUCT_API_ENDPOINT =
  process.env.REACT_APP_PRODUCT_API_ENDPOINT ||
  "https://apigateway-dev.muvistaging.com";
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const CreateTrialForm = ({
  formData,
  setFormData,
  productOptions,
  mailTriggerPopup,
  apiUrl,
  setApiUrl,
  closeModal,
  fixedCustomerDetails = false,
  mautic_id = null
}) => {
  const MUVI_ONE_CLASSIC_ID = "49F37046FCD84520895FC18A4F5BFC8B";

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [store, setStore] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [subdomain, setSubdomain] = useState("");
  const [subText, setSubText] = useState("");
  const [PRODUCT_NAME_CENTRALIZED, setPRODUCT_NAME_CENTRALIZED] = useState("");
  const [PRODUCT_TOKEN_CENTRALIZED, setPRODUCT_TOKEN_CENTRALIZED] =
    useState("");
  const [token, setToken] = useState("");

  useEffect(() => {
    fetchStoreExtension();
    const decryptedApiUrl = decryptConfigData("apiUrl");
    setApiUrl(decryptedApiUrl);
  }, []);

  const decryptConfigData = (configKey) => {
    const key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    const iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    const bytes = CryptoJS.AES.decrypt(config.get(configKey), key, { iv });
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  const fetchStoreExtension = () => {
    setStore("Don");
  };

  const getStoreExtension = () => {
    const ENV_NAME = process.env.REACT_APP_ENV_NAME || "dev";
    switch (ENV_NAME) {
      case "prod_muvi":
        return ".muvi.us";
      case "preprod":
        return "-staging.allthingsott.com";
      case "staging":
        return "-staging.muvistaging.com";
      case "dev":
        return "-dev.muvistaging.com";
      default:
        return ".muvi.us";
    }
  };

  const handleProductChange = (selectedOptions) => {
    const MAX_SELECTION = 3;
    // Check for the max selection limit
    if (selectedOptions.length > MAX_SELECTION) {
      alert("You can select up to 3 products only.");
      return;
    }

    let newOption = null;
    if (selectedOptions.length > selectedProducts.length) {
      newOption = selectedOptions.find(
        (option) =>
          !selectedProducts.some((selected) => selected.value === option.value)
      );
    }

    // Call the check function (you may need to define or import it)
    check(newOption);

    // Update the state
    setSelectedProducts(selectedOptions);

    // Clear the error for the products field if the selection is valid
    const updatedErrors = { ...errors };
    if (selectedOptions.length > 0) {
      delete updatedErrors.products; // Remove the error message for products
    }

    setFormData((prevState) => ({
      ...prevState,
      products: selectedOptions.map((option) => option.value),
    }));

    setErrors(updatedErrors); // Update the errors state
  };

  const check = (newOption) => {
    if (newOption && newOption.id === "1" && formData.customerName) {
      autofillDomainCentralized(
        formData.customerName,
        "3D28C83C85544F0D9517DD2E7C7EEDAA"
      );
    }
  };

  const handleSubdomainChange = (e) => setSubdomain(e.target.value);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      if (name === "customerName" && !fixedCustomerDetails) {
        updatedData.companyName = value
          .replace(/[^a-zA-Z0-9-]+/g, "-")
          .replace(/(^-+|-+$)/g, ""); // Auto-filling companyName from customerName
      }

      return updatedData;
    });

    // Clear errors for the field being changed
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      // If the customerName is updated, also clear the companyName error
      if (name === "customerName") {
        delete updatedErrors.companyName; // Clear companyName error if customerName changes
      }

      return updatedErrors;
    });
  };

  const emailValidation = () => {
    if (!emailPattern.test(formData.emailId)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        emailId: "Email is invalid!",
      }));
      return true;
    }
    return false;
  };

  const phoneValidation = () => {
    const phonePattern =
      /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,4}[-\s\.]?[0-9]{1,9}$/;

    if (!phonePattern.test(formData.phoneNumber)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phoneNumber: "Phone number is invalid! Must be digits.",
      }));
      return true;
    }
    return false;
  };

  const handleEmailValidation = async () => {
    if (!emailValidation()) {
      await validateEmail();
    }
  };

  // const validateEmail = async () => {
  //     const error = {};
  //     if (!formData.emailId) {
  //         error.emailId = "Email is required!";
  //     } else {
  //         await checkEmail(error, () => { });
  //     }
  //     setErrors(error);
  //     return Object.keys(error).length > 0;
  // };
  const validateEmail = async () => {
    const error = { ...errors }; // Preserve existing errors
    if (!formData.emailId) {
      error.emailId = "Email is required!";
    } else {
      await checkEmail(error, () => {});
    }
    setErrors(error);
    return Object.keys(error).length > 0;
  };

  const validateForm = () => {
    const {
      customerName,
      companyName,
      phoneNumber,
      emailId,
      password,
      products,
    } = formData;
    const validationErrors = {};

    if (!customerName.trim())
      validationErrors.customerName = "Please enter your name";
    if (!companyName.trim())
      validationErrors.companyName = "Please enter company name";
    if (!phoneNumber.trim())
      validationErrors.phoneNumber = "Please enter your phone number";
    if (!emailId.trim())
      validationErrors.emailId = "Please enter your email address";
    if (!password.trim())
      validationErrors.password = "Please provide a password";
    if (!products || products.length === 0)
      validationErrors.products = "Please select at least one product";

    if (emailId && emailId.trim() && !emailPattern.test(emailId)) {
      validationErrors.emailId = "Please enter a valid email address";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const checkIfAllFieldsFilled = () => {
    const {
      customerName,
      companyName,
      phoneNumber,
      emailId,
      password,
      products,
    } = formData;
    return (
      customerName &&
      companyName &&
      phoneNumber &&
      emailId &&
      password &&
      products.length > 0
    );
  };
  const checkEmail = async (error, callback) => {
    try {
      setIsLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_CRM}/crm/check-email`,
        {
          method: "POST",
          body: JSON.stringify({ email: formData.emailId }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const res = await response.json();

      if (res && res.code != 200) {
        error.emailId = res.message || "An error occurred. Please try again.";
        callback(false);
      } else {
        delete error.emailId;
        callback(true);
      }
    } catch (err) {
      console.error("Error validating email:", err);
      error.emailId = "An unexpected error occurred. Please try again.";
      callback(false);
    } finally {
      setIsLoading(false);
    }
  };

  const autofillDomainCentralized = async (domain, productId) => {
    if (!apiUrl) {
      console.error("API URL not available");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CRM}/crm/check-domain`,
        {
          method: "POST",
          body: JSON.stringify({
            subdomain: domain,
            key: productId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const res = await response.json();
      setSubdomain(res.domain ? res.domain.trim() : "");
      setSubText(res.domain ? res.domain.trim() : "");
    } catch (error) {
      console.error("Error fetching domain data:", error);
    }
  };

  const freetrial = async (product_key) => {
    const muvi_useruuid = Cookies.get("muvi_useruuid");
    
    try {
      setIsLoading(true);

      const commonPayload = {
        username: formData.customerName,
        company_name: formData.companyName,
        mobile: formData.phoneNumber,
        email: formData.emailId,
        password: formData.password,
        product_key: product_key,
        mautic_id: mautic_id || null,
        muvi_useruuid: muvi_useruuid || null,
      };

      let additionalPayload = {};
      if (selectedProducts[0] && selectedProducts[0].label === "Muvi Playout") {
        additionalPayload = {
          platform_options_uuid: [
            "4F3EBF655A4447C3A2CE57FB27BB5449",
            "451867C40B884A17B651467B2ECEBDF6",
          ],
        };
      } else if (
        selectedProducts[0] &&
        selectedProducts[0].label === "Muvi One"
      ) {
        additionalPayload = {
          domain: subdomain,
        };
      }

      const payload = { ...commonPayload, ...additionalPayload };

      const response = await fetch(
        process.env.REACT_APP_CRM + "/crm/free-trial",
        {
          method: "POST",
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const res = await response.json();
      console.log({ res });

      const token = res.response.token;
      console.log({ token });
      setToken(token);

      return res;
    } catch (error) {
      console.error("Error fetching domain data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const addProductCentralized = async (product_key, tToken) => {
    try {
      setIsLoading(true);

      console.log("Payload Sent to add-product:", {
        product_key: product_key,
        token: tToken,
      });

      const response = await fetch(
        `${process.env.REACT_APP_CRM}/crm/add-product`,
        {
          method: "POST",
          body: JSON.stringify({ product_key: product_key, token: tToken }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const res = await response.json();
      return res;
    } catch (error) {
      setErrors(error.message);
      console.error("Error adding product:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    setIsLoading(true);

    try {
      // Perform full form validation
      const isValidForm = await validateForm(); // validateForm sets the errors state internally
      console.log("Selected Products Array:", formData.products);
      console.log("Form Submitted:", formData);

      // Check if all fields are filled before validating email
      const isAllFieldsFilled = await checkIfAllFieldsFilled();

      if (!isAllFieldsFilled || !isValidForm) {
        // If fields are not filled or there are validation errors, stop the submission
        console.log("Form is incomplete or there are errors:", errors);
        setIsLoading(false); // Stop loading if validation fails
        return; // Exit the form submission process
      }

      // If all validations pass, make the API call
      const response = await emailCallBack(formData);

      console.log("API Response:", response); // Debugging: Check the response structure

      if (response && response.success) {
        console.log("Form Submitted Successfully:", formData);

        // Optionally reset form state after successful submission
        setFormData({
          customerName: "",
          companyName: "",
          phoneNumber: "",
          emailId: "",
          password: "",
          products: [],
        });
        setErrors({}); // Clear errors

        alert("Form submitted successfully!");
      } else {
        // Handle the case where the API call failed
        console.log("API submission failed:" || "Unknown error");
        // alert("Failed to submit the form. Please try again.");
      }
    } catch (error) {
      console.log("Submission Error:", error);
      // alert("An error occurred while submitting the form.mmmmm");
    } finally {
      setIsLoading(false); // Ensure loading state is reset
    }
  };

  const emailCallBack = async () => {
    const sortedSelectedProducts = selectedProducts;
    let isMounted = true;
    let isAccountCreated = false; // Track if any account was created

    try {
      // First API Call (freetrial for the first product)
      let result = await freetrial(
        sortedSelectedProducts[0] ? sortedSelectedProducts[0].value : ""
      );

      let appToken =
        result && result.response && result.response.app_token
          ? result.response.app_token
          : "";
      let tokenToPass =
        result && result.response && result.response.token
          ? result.response.token
          : token;

      if (
        isMounted &&
        result &&
        result.response &&
        result.response.code === 200
      ) {
        isAccountCreated = true; // First product succeeded

        // Second API Call (addProductCentralized for the second product)
        if (sortedSelectedProducts[1] !== undefined) {
          result = await addProductCentralized(
            sortedSelectedProducts[1] ? sortedSelectedProducts[1].value : "",
            tokenToPass
          );

          tokenToPass =
            result && result.response && result.response.token
              ? result.response.token
              : tokenToPass;

          if (
            isMounted &&
            result &&
            result.response &&
            result.response.code === 200
          ) {
            isAccountCreated = true; // Second product succeeded

            // Third API Call (addProductCentralized for the third product)
            if (sortedSelectedProducts[2] !== undefined) {
              result = await addProductCentralized(
                sortedSelectedProducts[2]
                  ? sortedSelectedProducts[2].value
                  : "",
                tokenToPass
              );
              if (result && result.response && result.response.code === 200) {
                isAccountCreated = true; // Third product succeeded
                toast.success("Account created successfully!");
              } else {
                toast.success("Account created successfully!");
              }
            } else {
              toast.success("Account created successfully!");
            }
          } else {
            if (sortedSelectedProducts[2] !== undefined) {
              result = await addProductCentralized(
                sortedSelectedProducts[2]
                  ? sortedSelectedProducts[2].value
                  : "",
                tokenToPass
              );
              if (result && result.response && result.response.code === 200) {
                isAccountCreated = true; // Third product succeeded
                toast.success("Account created successfully!");
              } else {
                toast.success("Account created successfully!");
              }
            } else {
              toast.success("Account created successfully!");
            }
          }
        } else {
          toast.success("Account created successfully!");
        }
      } else {
        if (sortedSelectedProducts[1] !== undefined) {
          result = await freetrial(
            sortedSelectedProducts[1] ? sortedSelectedProducts[1].value : ""
          );

          appToken =
            result && result.response && result.response.app_token
              ? result.response.app_token
              : "";
          tokenToPass =
            result && result.response && result.response.token
              ? result.response.token
              : tokenToPass;

          if (
            isMounted &&
            result &&
            result.response &&
            result.response.code === 200
          ) {
            isAccountCreated = true; // Second product succeeded

            if (sortedSelectedProducts[2] !== undefined) {
              result = await addProductCentralized(
                sortedSelectedProducts[2]
                  ? sortedSelectedProducts[2].value
                  : "",
                tokenToPass
              );
              if (
                isMounted &&
                result &&
                result.response &&
                result.response.code === 200
              ) {
                isAccountCreated = true; // Third product succeeded
                toast.success("Account created successfully!");
              } else {
                toast.success("Account created successfully!");
              }
            } else {
              toast.success("Account created successfully!");
            }
          } else {
            if (sortedSelectedProducts[2] !== undefined) {
              result = await freetrial(
                sortedSelectedProducts[2] ? sortedSelectedProducts[2].value : ""
              );
              appToken =
                result && result.response && result.response.app_token
                  ? result.response.app_token
                  : "";
              tokenToPass =
                result && result.response && result.response.token
                  ? result.response.token
                  : tokenToPass;

              if (
                isMounted &&
                result &&
                result.response &&
                result.response.code === 200
              ) {
                isAccountCreated = true; // Third product succeeded
                toast.success("Account created successfully!");
              } else {
                toast.success("Account created successfully!");
              }
            } else {
              toast.success("Account created successfully!");
            }
          }
        } else {
          toast.error(
            result.response.response ||
              "Failed to process the first product. Please try again!"
          );
        }
      }

      // Only call mailTriggerPopup if an account was created
      if (isAccountCreated) {
        await mailTriggerPopup(appToken);
      }
    } catch (error) {
      console.error("Error in emailCallback:", error);
      toast.error(
        "An error occurred while processing your request. Please try again!"
      );
    } finally {
      return () => {
        isMounted = false;
      };
    }
  };

  // const emailCallBack = async () => {
  //     const sortedSelectedProducts = selectedProducts;
  //     console.log({ sortedSelectedProducts });
  //     let isMounted = true;

  //     try {
  //         // First API Call (freetrial for the first product)
  //         let result = await freetrial(
  //             sortedSelectedProducts[0] ? sortedSelectedProducts[0].value : ""
  //         );
  //         console.log({ result });

  //         let tokenToPass = result && result.response && result.response.token ? result.response.token : token;
  //         console.log("Token passed for first product:", tokenToPass);

  //         const firstProductName = sortedSelectedProducts[0] ? sortedSelectedProducts[0].label : "Product 1";
  //         if (isMounted && result && result.response && result.response.code === 200) {
  //             // Second API Call (addProductCentralized for the second product)
  //             if (sortedSelectedProducts[1] !== undefined) {
  //                 result = await addProductCentralized(
  //                     sortedSelectedProducts[1] ? sortedSelectedProducts[1].value : "",
  //                     tokenToPass // Passing the token from the previous result or initial token
  //                 );
  //                 console.log("Result after second product API call:", result);

  //                 tokenToPass = result && result.response && result.response.token ? result.response.token : tokenToPass;
  //                 console.log("Token after second product:", tokenToPass);

  //                 const secondProductName = sortedSelectedProducts[1] ? sortedSelectedProducts[1].label : "Product 2";
  //                 if (isMounted && result && result.response && result.response.code === 200) {
  //                     // Third API Call (addProductCentralized for the third product)
  //                     if (sortedSelectedProducts[2] !== undefined) {
  //                         result = await addProductCentralized(
  //                             sortedSelectedProducts[2] ? sortedSelectedProducts[2].value : "",
  //                             tokenToPass // Ensure token is carried forward
  //                         );
  //                         console.log("Result after third product API call:", result);

  //                         const thirdProductName = sortedSelectedProducts[2] ? sortedSelectedProducts[2].label : "Product 3";
  //                         if (result && result.response && result.response.code === 200) {
  //                             toast.success(`Account created successfully with ${firstProductName}, ${secondProductName}, and ${thirdProductName}!`);
  //                         } else {
  //                             toast.success(`Account created successfully with ${firstProductName} and ${secondProductName}!`);
  //                         }
  //                     } else {
  //                         toast.success(`Account created successfully with ${firstProductName} and ${secondProductName}!`);
  //                     }
  //                 } else {
  //                     if (sortedSelectedProducts[2] !== undefined) {
  //                         result = await addProductCentralized(
  //                             sortedSelectedProducts[2] ? sortedSelectedProducts[2].value : "",
  //                             tokenToPass // Ensure token is carried forward
  //                         );
  //                         console.log("Result after fallback third product API call:", result);

  //                         if (result && result.response && result.response.code === 200) {
  //                             toast.success(`Account created successfully with ${firstProductName} and ${secondProductName}!`);
  //                         } else {
  //                             toast.success(`Account created successfully with ${firstProductName} and ${secondProductName}!`);
  //                         }
  //                     } else {
  //                         toast.success(`Account created successfully with ${firstProductName}!`);
  //                     }
  //                 }
  //             } else {
  //                 toast.success(`Account created successfully with ${firstProductName}!`);
  //             }
  //         } else {
  //             if (sortedSelectedProducts[1] !== undefined) {
  //                 result = await freetrial(
  //                     sortedSelectedProducts[1] ? sortedSelectedProducts[1].value : ""
  //                 );
  //                 console.log("Result after freetrial for second product:", result);

  //                 tokenToPass = result && result.response && result.response.token ? result.response.token : tokenToPass;
  //                 console.log("Token after freetrial for second product:", tokenToPass);

  //                 const secondProductName = sortedSelectedProducts[1] ? sortedSelectedProducts[1].label : "Product 2";
  //                 if (isMounted && result && result.response && result.response.code === 200) {
  //                     if (sortedSelectedProducts[2] !== undefined) {
  //                         result = await addProductCentralized(
  //                             sortedSelectedProducts[2] ? sortedSelectedProducts[2].value : "",
  //                             tokenToPass // Ensure token is carried forward
  //                         );
  //                         console.log("Result after third product API call:", result);

  //                         const thirdProductName = sortedSelectedProducts[2] ? sortedSelectedProducts[2].label : "Product 3";
  //                         if (isMounted && result && result.response && result.response.code === 200) {
  //                             toast.success(`Account created successfully with ${secondProductName} and ${thirdProductName}!`);
  //                         } else {
  //                             toast.success(`Account created successfully with ${secondProductName}!`);
  //                         }
  //                     }
  //                 } else {
  //                     if (sortedSelectedProducts[2] !== undefined) {
  //                         result = await freetrial(
  //                             sortedSelectedProducts[2] ? sortedSelectedProducts[2].value : ""
  //                         );
  //                         console.log("Result after freetrial for third product:", result);

  //                         tokenToPass = result && result.response && result.response.token ? result.response.token : tokenToPass;
  //                         console.log("Token after freetrial for third product:", tokenToPass);

  //                         const thirdProductName = sortedSelectedProducts[2] ? sortedSelectedProducts[2].label : "Product 3";
  //                         if (isMounted && result && result.response && result.response.code === 200) {
  //                             toast.success(`Account created successfully with ${thirdProductName}!`);
  //                         } else {
  //                             toast.success("Account created successfully with no products!");
  //                         }
  //                     }
  //                 }
  //             } else {
  //                 toast.error("Failed to process your request. Please try again!");
  //             }
  //         }

  //         await mailTriggerPopup();
  //     } catch (error) {
  //         console.error("Error in emailCallback:", error);
  //         toast.error("An error occurred while processing your request. Please try again!");
  //     } finally {
  //         return () => {
  //             isMounted = false;
  //         };
  //     }
  // };

  const renderInput = (name, label, type = "text", placeholder) => {
    return (
      <div className="my-3 w-100">
        <label
          className="form-label"
          style={{ fontSize: "13px", fontWeight: "400", marginBottom: "5px" }}
        >
          {label}
        </label>
        <input
          type={type === "password" && showPassword ? "text" : type}
          name={name}
          placeholder={placeholder}
          className="form-control w-100"
          style={{
            fontSize: "13px",
            borderRadius: "6px",
            padding: "10px",
            borderColor: "#ccc",
            marginBottom: "5px",
            fontWeight: "300",
          }}
          value={(formData && formData[name] && formData[name]) || ""}
          onChange={handleChange}
          onBlur={
            type === "email"
              ? handleEmailValidation
              : name === "phoneNumber"
              ? phoneValidation
              : undefined
          }
          autoComplete="off"
          disabled={fixedCustomerDetails && (name == "companyName" || name == "emailId")}
        />
        {type === "password" && (
          <span
            className={`fa fa-fw field-icon toggle-password fa-eye${
              !showPassword ? "-slash" : ""
            }`}
            style={{
              fontSize: "16px",
              cursor: "pointer",
              float: "right",
              marginRight: "10px",
              marginTop: "-32px",
              position: "relative",
              zIndex: 2,
            }}
            onClick={() => setShowPassword(!showPassword)}
          />
        )}
        {errors[name] && <span style={{ color: "red" }}>{errors[name]}</span>}
      </div>
    );
  };

  return (
    <React.Fragment>
      <form
        onSubmit={handleSubmit}
        style={{ width: "100%", height: "100%", position: "relative" }}
        autoComplete="off"
      >
        {/* Close Button */}
        {/* <button
          type="button"
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "16px",
            cursor: "pointer",
            color: "#333",
          }}
          aria-label="Close"
        >
          ✖
        </button> */}

        {/* Hidden Dummy Fields */}
        <input
          type="text"
          name="dummy-email"
          autoComplete="username"
          style={{
            position: "absolute",
            top: "-9999px",
            left: "-9999px",
            height: "0px",
            width: "0px",
            opacity: "0",
          }}
          tabIndex="-1"
        />
        <input
          type="password"
          name="dummy-password"
          autoComplete="new-password"
          style={{
            position: "absolute",
            top: "-9999px",
            left: "-9999px",
            height: "0px",
            width: "0px",
            opacity: "0",
          }}
          tabIndex="-1"
        />

        {/* <h5
          className="text-center mb-4"
          style={{
            fontWeight: "bold",
            fontSize: "18px",
            color: "#333",
            lineHeight: "24px",
            marginBottom: "8px",
            fontFamily: "Poppins",
          }}
        >
          Create a Trial Account
        </h5> */}

        {/* Name Input */}
        {renderInput("customerName", "Name", "text", "Name")}

        {/* Company Name Input */}
        {renderInput("companyName", "Company Name", "text", "Name")}

        {/* Phone Number Input */}
        {renderInput("phoneNumber", "Phone Number", "text", "Phone number")}

        {/* Email ID Input */}
        {renderInput("emailId", "Email ID", "email", "Email ID")}

        {/* Password Input */}
        {renderInput("password", "Password", "password", "Password")}

        {/* Products Select */}
        <div className="my-4 w-100">
          <label
            className="form-label"
            style={{
              fontSize: "13px",
              fontWeight: "400",
              lineHeight: "20px",
              color: "#666666",
              marginBottom: "5px",
            }}
          >
            Products
          </label>
          <Select
            isMulti
            options={(productOptions || []).filter((option) =>
              option.value !== MUVI_ONE_CLASSIC_ID
            )} // Exclude Muvi One Classic
            value={selectedProducts}
            onChange={handleProductChange}
            placeholder="Select up to 3 products..."
            className="w-100"
            styles={{
              control: (base) => ({
                ...base,
                borderRadius: "6px",
                padding: "5px",
                borderColor: "#ccc",
                fontSize: "13px",
                marginBottom: "5px",
                fontWeight: "300",
                border: "1px solid rgba(0, 0, 0, 0.12)",
              }),
              menu: (base) => ({
                ...base,
                borderRadius: "6px",
              }),
            }}
          />
          {errors.products && (
            <span className="error" style={{ color: "red", fontSize: "12px" }}>
              {errors.products}
            </span>
          )}
        </div>

        {/* Submit Button */}
        <div
          className="d-flex align-items-center"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginTop: "15px",
          }}
        >
          <button
            type="submit"
            className="btn btn-primary"
            style={{
              // backgroundColor: false ? "#52b7ed" : "#52b7ed",
              color: "#fff",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              border: "none",
              cursor:
                isLoading || Object.keys(errors).length > 0
                  ? "not-allowed"
                  : "pointer",
            }}
            disabled={isLoading || Object.keys(errors).length > 0}
          >
            {isLoading ? "Loading..." : "Create Trial Account"}
          </button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default CreateTrialForm;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/CreateTrialForm.js